// extracted by mini-css-extract-plugin
module.exports = {"copy-item":"CopyToClipboard-module__copy-item___3iwaQ","modal-counterparty":"CopyToClipboard-module__modal-counterparty___2EXL9"};